'use strict';

const h = require('phy');
const SelectLogo = require('./image_logo');

const EducationTouch = props => {
  const {
    dealProps,
    learnMoreText,
    savingsText: { education: savingsText },
    titleText,
    withSelectTouchText,
  } = props;

  const title = h('h2.select-widget__title', titleText);

  const ref = encodeURIComponent(dealProps.dealUrl);
  const learnMore = h(
    'p',
    h(
      'a.select-widget-link',
      {
        href: `/programs/select/subscribe?ref=${ref}`,
        'data-bhc': 'link:learn-more',
      },
      learnMoreText
    )
  );

  return h(
    'div#select-widget-education.t-pod.select-widget.select-widget__education',
    {
      'data-bhw': 'SelectEducationWidget',
      'data-bh-viewport': 'respect',
    },
    title,
    h(SelectLogo, props),
    h(
      'p.select-widget__body',
      h('span.select-widget__savings', savingsText),
      h('span', ` ${withSelectTouchText}`)
    ),
    learnMore
  );
};

module.exports = EducationTouch;
